import { setupLayouts } from 'virtual:generated-layouts'
import { pageview } from 'vue-gtag'
import { createRouter, createWebHistory } from 'vue-router'

import generatedRoutes from '~pages'

export {}

declare module 'vue-router' {
  interface RouteMeta {
    requiresAuth: boolean
    layout: string
  }
}

// generate routes
const routes = setupLayouts(generatedRoutes)

// add routes to router
export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

export function redirectToNoAccessPage() {
  router.replace({ name: 'no-access' })
}

export function redirectToErrorPage(title = 'Error', description = 'Something went wrong.', logout = false) {
  router.replace({ name: 'error', query: { title, description, logout: logout.toString() } })
}

export function redirectToPageNotFound() {
  router.replace({ name: 'notfound' })
}

router.beforeEach(async () => {})

router.afterEach((to, from, failure) => {
  if (!failure) {
    pageview({
      page_title: to.name as string,
      page_path: to.fullPath,
    })
  }
  document.title = 'Olive Payout'
})
